import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gradient-to-br from-purple-600 via-blue-600 to-purple-800 text-white" }
const _hoisted_2 = { class: "bg-black/10 backdrop-blur-md px-8 py-6 flex flex-col md:flex-row justify-between items-center gap-4" }
const _hoisted_3 = { class: "p-4 md:p-8 flex flex-col gap-8 max-w-4xl mx-auto" }
const _hoisted_4 = { class: "bg-white/10 backdrop-blur-md rounded-xl p-6 md:p-8 border border-white/20" }
const _hoisted_5 = { class: "flex flex-col gap-4" }
const _hoisted_6 = { class: "flex flex-col gap-2" }
const _hoisted_7 = { class: "flex flex-col gap-2" }
const _hoisted_8 = { class: "flex flex-col gap-2" }
const _hoisted_9 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_10 = { class: "flex flex-col gap-2" }
const _hoisted_11 = { class: "flex flex-col gap-2" }
const _hoisted_12 = { class: "flex flex-col md:flex-row gap-4 mt-4" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  key: 0,
  class: "mt-6 text-center"
}
const _hoisted_18 = {
  key: 1,
  class: "mt-6"
}
const _hoisted_19 = {
  key: 0,
  class: "bg-green-500/20 border border-green-500/30 rounded-lg p-4"
}
const _hoisted_20 = { class: "mb-2" }
const _hoisted_21 = {
  key: 1,
  class: "bg-red-500/20 border border-red-500/30 rounded-lg p-4"
}
const _hoisted_22 = { class: "mb-3" }
const _hoisted_23 = { class: "bg-white/10 backdrop-blur-md rounded-xl p-6 md:p-8 border border-white/20" }
const _hoisted_24 = {
  key: 0,
  class: "flex items-center justify-center gap-3 py-4"
}
const _hoisted_25 = {
  key: 1,
  class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6"
}
const _hoisted_26 = { class: "text-center p-4 bg-white/10 border border-white/20 rounded-lg" }
const _hoisted_27 = { class: "text-2xl md:text-3xl font-bold mb-2 text-green-400" }
const _hoisted_28 = { class: "text-center p-4 bg-white/10 border border-white/20 rounded-lg" }
const _hoisted_29 = { class: "text-2xl md:text-3xl font-bold mb-2 text-green-400" }
const _hoisted_30 = { class: "text-center p-4 bg-white/10 border border-white/20 rounded-lg" }
const _hoisted_31 = { class: "text-2xl md:text-3xl font-bold mb-2 text-green-400" }
const _hoisted_32 = { class: "text-center p-4 bg-white/10 border border-white/20 rounded-lg" }
const _hoisted_33 = { class: "text-2xl md:text-3xl font-bold mb-2 text-green-400" }
const _hoisted_34 = { class: "bg-white/10 backdrop-blur-md rounded-xl p-6 md:p-8 border border-white/20" }
const _hoisted_35 = { class: "mb-8 pb-6 border-b border-white/10" }
const _hoisted_36 = { class: "flex flex-col gap-2 mb-4" }
const _hoisted_37 = { class: "flex items-center gap-3 cursor-pointer" }
const _hoisted_38 = { class: "mb-6" }
const _hoisted_39 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_40 = { class: "flex flex-col gap-2" }
const _hoisted_41 = { class: "flex flex-col gap-2" }

import { ref, onMounted } from 'vue'
import axios from 'axios';
import configuration from '@/config/config';

interface ImportResult {
  success: boolean
  message: string
  count?: number
}

interface Stats {
  totalRecords: number
  totalComuni: number
  totalOperatori: number
  rangeDate: string
}

interface Config {
  soapUrl: string
  saveCredentials: boolean
  refreshInterval: number
  recordsPerPage: number
}

// Reactive state

export default /*@__PURE__*/_defineComponent({
  __name: 'AdminPianificazioni',
  setup(__props) {

const importing = ref(false)
const loadingStats = ref(false)
const importResult = ref<ImportResult | null>(null)
const stats = ref<Stats | null>(null)

// Form data
const credentials = ref({
  username: 'sched_webservice',
  password: '%ix5QY+BVeb%ZkL',
  company: '001'
})

const dateRange = ref({
  dataInizio: '',
  dataFine: ''
})

const config = ref<Config>({
  soapUrl: 'https://hrp.serit.info/ZScheduling/servlet/SQLDataProviderServer/SERVLET/hut_export_pianific?wsdl',
  saveCredentials: false,
  refreshInterval: 30,
  recordsPerPage: 50
})

// API base URL
const API_BASE = configuration.API_BASE_URL  || 'http://localhost:3454'

// Methods
async function importData() {
  importing.value = true
  importResult.value = null

  try {
    const response = await axios.post(`${API_BASE}/api/pianificazioni/fetch`, {
      username: credentials.value.username,
      password: credentials.value.password,
      company: credentials.value.company,
      dataInizio: dateRange.value.dataInizio,
      dataFine: dateRange.value.dataFine
    }, {
      timeout: 420000 // 7 minuti
    })

    importResult.value = {
      success: true,
      message: response.data.message,
      count: response.data.count
    }

    // Ricarica le statistiche dopo un import riuscito
    setTimeout(loadStats, 1000)

  } catch (error: unknown) {
    let message = 'Errore sconosciuto'
    if (typeof error === 'object' && error !== null) {
      const err = error as { response?: { data?: { message?: string } }, message?: string }
      message = err.response?.data?.message || err.message || message
    }
    importResult.value = {
      success: false,
      message
    }
  } finally {
    importing.value = false
  }
}

async function loadStats() {
  loadingStats.value = true
  
  try {
    // Simulated stats - replace with actual API call
    await new Promise(resolve => setTimeout(resolve, 500))
    
    stats.value = {
      totalRecords: 1247,
      totalComuni: 15,
      totalOperatori: 42,
      rangeDate: '10/03/2025 - 16/03/2025'
    }
  } catch (error) {
    console.error('Error loading stats:', error)
  } finally {
    loadingStats.value = false
  }
}

function setCurrentWeek() {
  const today = new Date()
  const currentDay = today.getDay()
  
  // Calcola il lunedì della settimana corrente
  let monday = new Date(today)
  
  if (currentDay === 0) {
    // Se oggi è domenica, la "settimana corrente" è quella che inizia domani (lunedì)
    monday.setDate(today.getDate() + 1)
  } else {
    // Per tutti gli altri giorni, trova il lunedì di questa settimana
    monday.setDate(today.getDate() - (currentDay - 1))
  }
  
  monday.setHours(0, 0, 0, 0)
  
  const sunday = new Date(monday)
  sunday.setDate(monday.getDate() + 6)
  sunday.setHours(23, 59, 59, 999)

  dateRange.value.dataInizio = formatDateForInput(monday)
  dateRange.value.dataFine = formatDateForInput(sunday)
}

function formatDateForInput(date: Date): string {
  // Usa le componenti locali della data per evitare problemi di fuso orario
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

function tryAgain() {
  importData()
}

async function exportData() {
  try {
    const response = await axios.get(`${API_BASE}/api/pianificazioni/export`, {
      responseType: 'blob'
    })
    
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.download = `pianificazioni_${new Date().toISOString().split('T')[0]}.csv`
    link.click()
    window.URL.revokeObjectURL(url)
  } catch (error) {
    console.error('Error exporting data:', error)
  }
}

function saveConfig() {
  localStorage.setItem('admin_config', JSON.stringify(config.value))
  
  if (config.value.saveCredentials) {
    localStorage.setItem('soap_credentials', JSON.stringify(credentials.value))
  } else {
    localStorage.removeItem('soap_credentials')
  }
  
  alert('Configurazione salvata!')
}

function resetConfig() {
  config.value = {
    soapUrl: 'http://your-soap-endpoint.com/service?wsdl',
    saveCredentials: false,
    refreshInterval: 30,
    recordsPerPage: 50
  }
  
  localStorage.removeItem('admin_config')
  localStorage.removeItem('soap_credentials')
  
  alert('Configurazione ripristinata ai valori predefiniti!')
}

function loadConfig() {
  const savedConfig = localStorage.getItem('admin_config')
  if (savedConfig) {
    config.value = { ...config.value, ...JSON.parse(savedConfig) }
  }
  
  if (config.value.saveCredentials) {
    const savedCredentials = localStorage.getItem('soap_credentials')
    if (savedCredentials) {
      credentials.value = { ...credentials.value, ...JSON.parse(savedCredentials) }
    }
  }
}

// Lifecycle
onMounted(() => {
  setCurrentWeek()
  loadConfig()
  loadStats()
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[10] || (_cache[10] = _createElementVNode("h1", { class: "text-2xl md:text-3xl font-light m-0" }, "Pannello Amministrazione", -1)),
      _createVNode(_component_router_link, {
        to: "/monitor",
        class: "px-6 py-3 bg-white/20 border border-white/30 rounded-lg transition-all duration-300 hover:bg-white/30 hover:-translate-y-0.5 text-white no-underline"
      }, {
        default: _withCtx(() => _cache[9] || (_cache[9] = [
          _createTextVNode(" 🖥️ Vai al Monitor ")
        ])),
        _: 1,
        __: [9]
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _cache[20] || (_cache[20] = _createElementVNode("h2", { class: "text-xl md:text-2xl font-medium mb-4" }, "Import Dati SOAP", -1)),
        _cache[21] || (_cache[21] = _createElementVNode("p", { class: "opacity-90 leading-relaxed mb-6" }, " Importa i dati di pianificazione dal servizio SOAP per un periodo specifico. ", -1)),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[11] || (_cache[11] = _createElementVNode("label", {
              for: "username",
              class: "font-medium text-sm"
            }, "Username:", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "username",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((credentials.value.username) = $event)),
              type: "text",
              required: "",
              placeholder: "Nome utente SOAP",
              autocomplete: "new-password",
              "data-form-type": "other",
              class: "px-3 py-2.5 border border-white/30 rounded-md bg-white/10 text-white placeholder-white/60 focus:outline-none focus:border-white/60 focus:bg-white/15"
            }, null, 512), [
              [_vModelText, credentials.value.username]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[12] || (_cache[12] = _createElementVNode("label", {
              for: "password",
              class: "font-medium text-sm"
            }, "Password:", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "password",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((credentials.value.password) = $event)),
              type: "text",
              required: "",
              placeholder: "Password SOAP",
              autocomplete: "new-password",
              "data-form-type": "other",
              style: {"-webkit-text-security":"disc","text-security":"disc"},
              class: "px-3 py-2.5 border border-white/30 rounded-md bg-white/10 text-white placeholder-white/60 focus:outline-none focus:border-white/60 focus:bg-white/15"
            }, null, 512), [
              [_vModelText, credentials.value.password]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[13] || (_cache[13] = _createElementVNode("label", {
              for: "company",
              class: "font-medium text-sm"
            }, "Company:", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "company",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((credentials.value.company) = $event)),
              type: "text",
              required: "",
              placeholder: "Codice azienda (es. 001)",
              maxlength: "3",
              autocomplete: "off",
              class: "px-3 py-2.5 border border-white/30 rounded-md bg-white/10 text-white placeholder-white/60 focus:outline-none focus:border-white/60 focus:bg-white/15"
            }, null, 512), [
              [_vModelText, credentials.value.company]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _cache[14] || (_cache[14] = _createElementVNode("label", {
                for: "dataInizio",
                class: "font-medium text-sm"
              }, "Data Inizio:", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "dataInizio",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dateRange.value.dataInizio) = $event)),
                type: "date",
                required: "",
                class: "px-3 py-2.5 border border-white/30 rounded-md bg-white/10 text-white focus:outline-none focus:border-white/60 focus:bg-white/15"
              }, null, 512), [
                [_vModelText, dateRange.value.dataInizio]
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[15] || (_cache[15] = _createElementVNode("label", {
                for: "dataFine",
                class: "font-medium text-sm"
              }, "Data Fine:", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "dataFine",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dateRange.value.dataFine) = $event)),
                type: "date",
                required: "",
                class: "px-3 py-2.5 border border-white/30 rounded-md bg-white/10 text-white focus:outline-none focus:border-white/60 focus:bg-white/15"
              }, null, 512), [
                [_vModelText, dateRange.value.dataFine]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              type: "button",
              onClick: importData,
              class: "px-6 py-3 bg-green-500 text-white rounded-md font-medium transition-all duration-300 hover:bg-green-600 disabled:opacity-50 disabled:cursor-not-allowed",
              disabled: importing.value
            }, [
              (importing.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, "⟳ Importando..."))
                : (_openBlock(), _createElementBlock("span", _hoisted_15, "📥 Importa Dati"))
            ], 8, _hoisted_13),
            _createElementVNode("button", {
              type: "button",
              onClick: setCurrentWeek,
              class: "px-6 py-3 bg-white/20 border border-white/30 text-white rounded-md transition-all duration-300 hover:bg-white/30 disabled:opacity-50",
              disabled: importing.value
            }, " 📅 Settimana Corrente ", 8, _hoisted_16)
          ])
        ]),
        (importing.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, _cache[16] || (_cache[16] = [
              _createElementVNode("div", { class: "w-full h-1.5 bg-white/20 rounded-full overflow-hidden mb-2" }, [
                _createElementVNode("div", { class: "h-full bg-gradient-to-r from-green-500 to-green-400 animate-pulse" })
              ], -1),
              _createElementVNode("p", { class: "text-sm" }, "Import in corso... Questa operazione potrebbe richiedere alcuni minuti.", -1)
            ])))
          : _createCommentVNode("", true),
        (importResult.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              (importResult.value.success)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _cache[18] || (_cache[18] = _createElementVNode("h3", { class: "text-lg font-medium mb-2" }, "✅ Import completato con successo!", -1)),
                    _createElementVNode("p", _hoisted_20, _toDisplayString(importResult.value.message), 1),
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, _toDisplayString(importResult.value.count), 1),
                      _cache[17] || (_cache[17] = _createTextVNode(" record importati."))
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _cache[19] || (_cache[19] = _createElementVNode("h3", { class: "text-lg font-medium mb-2" }, "❌ Errore durante l'import", -1)),
                    _createElementVNode("p", _hoisted_22, _toDisplayString(importResult.value.message), 1),
                    _createElementVNode("button", {
                      onClick: tryAgain,
                      class: "px-4 py-2 bg-red-500 text-white rounded-md transition-all duration-300 hover:bg-red-600"
                    }, " 🔄 Riprova ")
                  ]))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_23, [
        _cache[27] || (_cache[27] = _createElementVNode("h2", { class: "text-xl md:text-2xl font-medium mb-6" }, "Statistiche Database", -1)),
        (loadingStats.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, _cache[22] || (_cache[22] = [
              _createElementVNode("div", { class: "w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" }, null, -1),
              _createElementVNode("span", null, "Caricamento statistiche...", -1)
            ])))
          : (stats.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, _toDisplayString(stats.value.totalRecords), 1),
                  _cache[23] || (_cache[23] = _createElementVNode("div", { class: "text-sm opacity-80" }, "Totale Record", -1))
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, _toDisplayString(stats.value.totalComuni), 1),
                  _cache[24] || (_cache[24] = _createElementVNode("div", { class: "text-sm opacity-80" }, "Comuni", -1))
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, _toDisplayString(stats.value.totalOperatori), 1),
                  _cache[25] || (_cache[25] = _createElementVNode("div", { class: "text-sm opacity-80" }, "Operatori", -1))
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, _toDisplayString(stats.value.rangeDate), 1),
                  _cache[26] || (_cache[26] = _createElementVNode("div", { class: "text-sm opacity-80" }, "Periodo Dati", -1))
                ])
              ]))
            : _createCommentVNode("", true),
        _createElementVNode("div", { class: "flex flex-col md:flex-row gap-4 justify-center" }, [
          _createElementVNode("button", {
            onClick: loadStats,
            class: "px-6 py-3 bg-white/20 border border-white/30 text-white rounded-md transition-all duration-300 hover:bg-white/30"
          }, " 🔄 Aggiorna Statistiche "),
          _createElementVNode("button", {
            onClick: exportData,
            class: "px-6 py-3 bg-blue-500 text-white rounded-md transition-all duration-300 hover:bg-blue-600"
          }, " 📊 Esporta CSV ")
        ])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _cache[34] || (_cache[34] = _createElementVNode("h2", { class: "text-xl md:text-2xl font-medium mb-6" }, "Configurazione", -1)),
        _createElementVNode("div", _hoisted_35, [
          _cache[30] || (_cache[30] = _createElementVNode("h3", { class: "text-lg mb-4 text-green-400" }, "Impostazioni SOAP", -1)),
          _createElementVNode("div", _hoisted_36, [
            _cache[28] || (_cache[28] = _createElementVNode("label", {
              for: "soapUrl",
              class: "font-medium text-sm"
            }, "URL Servizio SOAP:", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "soapUrl",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((config.value.soapUrl) = $event)),
              type: "url",
              placeholder: "http://your-soap-endpoint.com/service?wsdl",
              autocomplete: "off",
              class: "px-3 py-2.5 border border-white/30 rounded-md bg-white/10 text-white placeholder-white/60 focus:outline-none focus:border-white/60 focus:bg-white/15"
            }, null, 512), [
              [_vModelText, config.value.soapUrl]
            ])
          ]),
          _createElementVNode("label", _hoisted_37, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((config.value.saveCredentials) = $event)),
              type: "checkbox",
              class: "w-4 h-4 text-green-500 bg-white/10 border-white/30 rounded focus:ring-green-500 focus:ring-2"
            }, null, 512), [
              [_vModelCheckbox, config.value.saveCredentials]
            ]),
            _cache[29] || (_cache[29] = _createElementVNode("span", null, "Salva credenziali localmente (solo per sviluppo)", -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_38, [
          _cache[33] || (_cache[33] = _createElementVNode("h3", { class: "text-lg mb-4 text-green-400" }, "Impostazioni Monitor", -1)),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _cache[31] || (_cache[31] = _createElementVNode("label", {
                for: "refreshInterval",
                class: "font-medium text-sm"
              }, "Intervallo Auto-refresh (secondi):", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "refreshInterval",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((config.value.refreshInterval) = $event)),
                type: "number",
                min: "10",
                max: "300",
                class: "px-3 py-2.5 border border-white/30 rounded-md bg-white/10 text-white focus:outline-none focus:border-white/60 focus:bg-white/15"
              }, null, 512), [
                [
                  _vModelText,
                  config.value.refreshInterval,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _cache[32] || (_cache[32] = _createElementVNode("label", {
                for: "recordsPerPage",
                class: "font-medium text-sm"
              }, "Record per pagina:", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "recordsPerPage",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((config.value.recordsPerPage) = $event)),
                type: "number",
                min: "10",
                max: "100",
                class: "px-3 py-2.5 border border-white/30 rounded-md bg-white/10 text-white focus:outline-none focus:border-white/60 focus:bg-white/15"
              }, null, 512), [
                [
                  _vModelText,
                  config.value.recordsPerPage,
                  void 0,
                  { number: true }
                ]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", { class: "flex flex-col md:flex-row gap-4 justify-center" }, [
          _createElementVNode("button", {
            onClick: saveConfig,
            class: "px-6 py-3 bg-green-500 text-white rounded-md transition-all duration-300 hover:bg-green-600"
          }, " 💾 Salva Configurazione "),
          _createElementVNode("button", {
            onClick: resetConfig,
            class: "px-6 py-3 bg-orange-500 text-white rounded-md transition-all duration-300 hover:bg-orange-600"
          }, " 🔄 Reset Default ")
        ])
      ])
    ])
  ]))
}
}

})